import { render, staticRenderFns } from "./StatusTab.vue?vue&type=template&id=b8827d18&scoped=true&"
import script from "./StatusTab.vue?vue&type=script&lang=ts&"
export * from "./StatusTab.vue?vue&type=script&lang=ts&"
import style0 from "./StatusTab.vue?vue&type=style&index=0&id=b8827d18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8827d18",
  null
  
)

export default component.exports